import {
  requestMerchantInfo,
  responseMerchantInfo,
  failureMerchantInfo,
} from '../../slices/merchantInfoSlice/merchantInfoSlice';
import requestApi from 'utils/Request';
import { MERCHANT_INFO } from '../../../utils/StaticApiEndpoints';
import Swal from 'sweetalert2';

//////// Merchant Info List //////////
export const ListMerchantInfoData = (payload) => async (dispatch) => {
  try {
    dispatch(requestMerchantInfo());
    const res = await requestApi.get(MERCHANT_INFO, { params: payload });
    dispatch(responseMerchantInfo(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureMerchantInfo(error?.message));
  }
};
